<template>
  <!-- Template para la vision y mision -->
  <div class="nosotros-container">
    <!-- Misión Section -->
    <section class="mission-section">
      <div class="container">
        <div class="content-wrapper">
          <h2 class="section-title">Nuestra Misión</h2>
          <div class="mission-content">
            <div class="content-decoration">
              <div class="decoration-circle circle-1"></div>
              <div class="decoration-circle circle-2"></div>
              <div class="decoration-circle circle-3"></div>
            </div>
            <p class="mission-text">
              En Rodasep Rodamientos Séptima Región nos dedicamos a diseñar y
              suministrar soluciones a medida de rodamientos para los sectores
              industrial, automotriz y agrícola, combinando experiencia técnica
              de vanguardia con un servicio ágil y cercano. Desde nuestras sedes
              en Talca, Curicó y Linares, garantizamos la continuidad operativa
              de nuestros clientes gracias a un enfoque familiar que prioriza la
              confiabilidad y la asesoría especializada en cada proyecto.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Visión Section -->
    <section class="vision-section">
      <div class="container">
        <div class="content-wrapper">
          <h2 class="section-title">Nuestra Visión</h2>
          <div class="vision-content">
            <div class="content-decoration">
              <div class="decoration-circle circle-1"></div>
              <div class="decoration-circle circle-2"></div>
              <div class="decoration-circle circle-3"></div>
            </div>
            <p class="vision-text">
              Aspiramos a transformar el centro-sur de Chile en un polo de
              excelencia mecánica, consolidándonos como el aliado preferido para
              el movimiento industrial. Visualizamos una Rodasep en constante
              evolución—ampliando su oferta con soluciones innovadoras y
              sostenibles, incorporando herramientas digitales avanzadas y
              abriendo nuevos mercados—sin renunciar jamás a la calidez y el
              compromiso que solo una empresa familiar puede ofrecer.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Team Header Section -->
    <section class="team-header-section">
      <div class="container">
        <div class="team-header">
          <h2 class="section-title-p">Conoce Nuestro Equipo</h2>
          <p class="team-subtitle">Profesionales comprometidos contigo</p>
        </div>
      </div>
    </section>
  </div>

  <!-- Template para el personal -->
  <div class="personal-section">
    <div class="container">
      <div class="team-grid">
        <div v-for="person in team" :key="person.id" class="team-card">
          <div class="card-inner">
            <div class="image-container">
              <img
                :src="person.image"
                :alt="person.name"
                class="person-image"
              />
              <div class="overlay">
                <div class="overlay-content">
                  <h3 class="person-name">{{ person.name }}</h3>
                  <p class="person-role">{{ person.role }}</p>
                  <p class="person-description">{{ person.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RodasepNosotros", // Puedes dejar este como principal

  data() {
    return {
      team: [
        {
          id: 1,
          name: "Eduardo Calderón",
          role: "Asesor experto en rodamientos",
          description:
            "Especialista con años en asesoría técnica y selección de rodamientos de alta confiabilidad.",
          image: require("@/assets/images/personal/p_1.webp"),
        },
        {
          id: 2,
          name: "Juan Carlos",
          role: "Ejecutivo de Ventas",
          description:
            "Acompaña al cliente con orientación detallada y seguimiento personalizado en cada proyecto.",
          image: require("@/assets/images/personal/p_2.webp"),
        },
        {
          id: 3,
          name: "Alexander Parra",
          role: "Ejecutivo de Ventas",
          description:
            "Ofrece respuestas ágiles y asesoramiento claro para aplicaciones automotrices e industriales.",
          image: require("@/assets/images/personal/p_3.webp"),
        },
        {
          id: 4,
          name: "Marcelo Gutierrez",
          role: "Ejecutivo de Ventas",
          description:
            "Identifica las mejores opciones de rodamientos para optimizar rendimiento y durabilidad.",
          image: require("@/assets/images/personal/p_4.webp"),
        },
      ],
    };
  },

  mounted() {
    this.animateOnScroll(); // 👉 Se ejecuta cuando se monta el componente
  },

  methods: {
    animateOnScroll() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          }
        });
      }, observerOptions);

      document
        .querySelectorAll(
          ".mission-section, .vision-section, .team-header-section"
        )
        .forEach((el) => {
          observer.observe(el);
        });
    },
  },
};
</script>

<style scoped>
/* Font Face Definitions */
@font-face {
  font-family: "Playfair Display";
  src: url("~@/assets/fonts/playfair-display/PlayfairDisplay-Regular.ttf")
    format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Playfair Display";
  src: url("~@/assets/fonts/playfair-display/PlayfairDisplay-Bold.ttf")
    format("truetype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Playfair Display";
  src: url("~@/assets/fonts/playfair-display/PlayfairDisplay-SemiBold.ttf")
    format("truetype");
  font-weight: 600;
  font-style: normal;
}

/* Variables CSS */
:root {
  --primary-color: #2c5aa0;
  --secondary-color: #1a4480;
  --accent-color: #f39c12;
  --dark-color: #2c3e50;
  --light-color: #ecf0f1;
  --text-color: #34495e;
  --gradient-primary: linear-gradient(
    135deg,
    var(--primary-color),
    var(--secondary-color)
  );
  --gradient-accent: linear-gradient(135deg, var(--accent-color), #e67e22);
  --gradient-soft: linear-gradient(
    145deg,
    #ffffff 0%,
    #f8f9fa 50%,
    #e9ecef 100%
  );
  --shadow-elegant: 0 25px 50px rgba(44, 90, 160, 0.15);
}

/* Reset y Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.nosotros-container {
  font-family: "Playfair Display", serif;
  line-height: 1.6;
  color: var(--text-color);
  padding-top: 1rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Section Titles */
.section-title {
  font-size: 3.5rem;
  font-weight: 10;
  color: var(--dark-color);
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  font-family: "Playfair Display", serif;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.1); /*Efecto Cremoso*/
}
.section-title-p {
  font-size: 3.5rem;
  font-weight: 10;
  color: var(--dark-color);
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  font-family: "Playfair Display", serif;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.1); /*Efecto Cremoso*/
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 250px;
  height: 1px;
  background-color: #00a9e0; /*Color subrayado titulo*/
}

.section-title-p::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 350px;
  height: 0.1px;
  background-color: #00a9e0; /*Color subrayado titulo*/
}

/* Mission & Vision Sections */
.mission-section,
.vision-section {
  padding: 4rem 0;
  background: white;
  position: relative;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.mission-section.fade-in,
.vision-section.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.content-wrapper {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.mission-content,
.vision-content {
  background: var(--gradient-soft);
  padding: 3rem 3rem;
  border-radius: 30px;
  box-shadow: var(--shadow-elegant);
  position: relative;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
}

.mission-content::before,
.vision-content::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: var(--gradient-primary);
  border-radius: 32px;
  z-index: -1;
  opacity: 0.1;
}

.mission-content::after,
.vision-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: var(--gradient-primary);
  border-radius: 30px 30px 0 0;
}

/* Decoraciones elegantes */
.content-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.decoration-circle {
  position: absolute;
  border-radius: 100%;
  background: linear-gradient(
    45deg,
    rgba(0, 169, 224, 0.05),
    rgba(0, 169, 224, 0.05)
  );
}

.circle-1 {
  width: 150px;
  height: 150px;
  top: -75px;
  right: -75px;
  animation: float 6s ease-in-out infinite;
}

.circle-2 {
  width: 100px;
  height: 100px;
  bottom: -50px;
  left: -50px;
  animation: float 8s ease-in-out infinite reverse;
}

.circle-3 {
  width: 80px;
  height: 80px;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  animation: float 7s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.mission-text,
.vision-text {
  font-size: 1.3rem;
  line-height: 1.9;
  color: var(--text-color);
  font-weight: 400;
  text-align: center;
  max-width: 750px;
  margin: 0 auto;
  font-family: "Playfair Display", serif;
  position: relative;
  z-index: 2;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

/* Team Header Section */
.team-header-section {
  padding: 4rem 0 2rem 0;
  background: white;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.team-header-section.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.team-header {
  text-align: center;
}

.team-subtitle {
  font-size: 1.4rem;
  color: var(--text-color);
  font-weight: 400;
  opacity: 0.8;
  font-style: italic;
  margin-top: 1rem;
}

/* Animations */
.fade-in {
  animation: fadeInUp 0.8s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .section-title {
    font-size: 2.5rem;
  }

  .section-title-p {
    font-size: 2.5rem;
  }

  .mission-content,
  .vision-content {
    padding: 3rem 2rem;
    margin: 0 1rem;
    border-radius: 20px;
  }

  .mission-text,
  .vision-text {
    font-size: 1.1rem;
    line-height: 1.7;
  }

  .container {
    padding: 0 1rem;
  }

  .nosotros-container {
    padding-top: 2rem;
  }

  .mission-section,
  .vision-section {
    padding: 3rem 0;
  }

  .team-header-section {
    padding: 3rem 0 1rem 0;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 2rem;
  }

  .section-title-p {
    font-size: 2rem;
  }

  .mission-content,
  .vision-content {
    padding: 2.5rem 1.5rem;
  }

  .mission-text,
  .vision-text {
    font-size: 1rem;
  }

  .team-subtitle {
    font-size: 1.2rem;
  }
}

/*########################################*/
/* ESTILO CSS PARA IMAGENES DEL PERSONAL */
/*########################################*/
.personal-section {
  padding: 80px 0;
  background: #ffffff;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  justify-items: center;
  width: 100%;
}

.team-card {
  position: relative;
  width: 100%;
  max-width: 280px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 20px;
  overflow: hidden;
}

.team-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  animation: none;
}

.card-inner {
  width: 100%;
  height: 100%;
  transition: all 0.4s ease;
}

.image-container {
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  position: relative;
}

.person-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: all 0.4s ease;
}

.team-card:hover .person-image {
  transform: scale(1.02);
  filter: brightness(0.9);
}

.overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.95),
    rgba(0, 169, 224, 0.95)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.4s ease;
}

.team-card:hover .overlay {
  opacity: 1;
}

.overlay-content {
  color: white;
  text-align: center;
  padding: 20px;
}

.person-name {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 6px;
}

.person-role {
  font-size: 1rem;
  font-weight: 600;
  color: #feca57;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.person-description {
  font-size: 0.95rem;
  line-height: 1.5;
  opacity: 0.9;
  margin-bottom: 12px;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.team-card:nth-child(odd) {
  animation: float 6s ease-in-out infinite;
}

.team-card:nth-child(even) {
  animation: float 6s ease-in-out infinite reverse;
}

@media (max-width: 1024px) {
  .team-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .team-grid {
    grid-template-columns: 1fr;
  }

  .team-card {
    max-width: 100%;
  }

  .person-name {
    font-size: 1.3rem;
  }

  .person-role {
    font-size: 0.9rem;
  }

  .person-description {
    font-size: 0.85rem;
  }
}
</style>
